import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { FusePageCarded, FuseAnimateGroup } from '@fuse';
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Button, Tab, Tabs, Icon, IconButton } from '@material-ui/core';
import ReactTable from "react-table";
import * as Actions from './store/actions';
import * as TableActions from 'main/components/tableSort/store/actions';
import _ from 'lodash';
import TableCellTooltip from '../../components/TableCellTooltip';

const styles = theme => ({
    layoutRoot   : {},
    layoutToolbar: {
        padding: 0
    },
    tabsRoot     : {
        height: 64
    },
    tabRoot      : {
        height: 64
    },
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: '80%',
    },
    textFieldSearch: {
        marginLeft: theme.spacing.unit,
        width: '95%',
    },
    button: {
        margin: theme.spacing.unit,
    },
});

class EventStudentList extends Component {
    state = {
        current_tab:   0,
        gradebook_id:  0,
    }

    constructor(props) {
        super(props);

        const gradebook_id = this.props.match.params.gradebook_id;

        this.state = {
            ...this.state,
            gradebook_id: gradebook_id,
        }
    }

    componentDidMount = () => {
        const auth_id = this.props.auth.user.data.auth_id;

        this.props.getCourseList(auth_id);
    }

    handleRowClick = (course_info) => {
        const { company_calendar_course_id } = course_info;
        const auth_role                      = this.props.auth.user.role;

        if(auth_role === "student") {
            this.props.history.push(`/gradebook/student/event_list/${company_calendar_course_id}`);
        } else {
            this.props.history.push(`/gradebook/${company_calendar_course_id}`);
        }
    }

    getPageContent = (current_tab) => {
        const { courseList, table_sort, table_filter, table_page_size, is_loaded } = this.props;
        const auth_role      = this.props.auth.user.role;
        const table_name     = this.constructor.name;
        
        if (!is_loaded) return <React.Fragment>Loading...</React.Fragment>;

        switch(current_tab)
        {
            case(0): // Course List
            {
                return (
                    <ReactTable
                        style={{ position: 'absolute' }}
                        columns={[
                            {
                                Header: "Course Name",
                                accessor: "CourseName",
                                Cell: row => (
                                    <TableCellTooltip
                                        item={row.original.CourseName}
                                        chars={20}
                                    />
                                )
                            },
                            {
                                Header: "Company",
                                accessor: "CompanyName"
                            },
                            {
                                Header: "Start Date",
                                accessor: "StartDate"
                            },
                            {
                                Header: "End Date",
                                accessor: "EndDate",
                            },
                            {
                                Header: "Status",
                                accessor: "status",
                                show: auth_role === 'student'
                            },
                            {
                                Header: "Grade",
                                Cell: (row) => (
                                    <IconButton
                                    style={{ padding: '0px', marginLeft: '5px', marginRight: '5px' }}
                                        onClick={(ev) => {
                                            ev.stopPropagation();
                                            this.handleRowClick(row.original);
                                        }}
                                    >
                                        <Icon>assignment</Icon>
                                    </IconButton>
                                )
                            }
                        ]}
                        data={courseList}
                        defaultPageSize={25}
                        pageSize={table_page_size[table_name]}
                        className="-striped -highlight"
                        noDataText="No Events Found"
                        defaultSorted={table_sort[table_name]}
                        onSortedChange={(sort_list) => this.props.setTableSort(this.props.auth.user.data.auth_id, table_name, sort_list)}
                        filterable={true}
                        defaultFiltered={table_filter[table_name]}
                        onFilteredChange={_.debounce((filter_list) => this.props.setTableFilter(this.props.auth.user.data.auth_id, table_name, filter_list), 500)}
                        onPageSizeChange={(page_size) => this.props.setTablePageSize(this.props.auth.user.data.auth_id, table_name, page_size)}
                    />
                );
            }
            
            default:
            {
                return <React.Fragment>Error: No tab found.</React.Fragment>
            }
        }
    }

    handleChangeTab = (event, value) => {
        this.setState({
            ...this.state,
            current_tab: value
        });
    }

    render() {
        const { classes }    = this.props;
        const { current_tab} = this.state;
        const page_content   = this.getPageContent(current_tab);
        
        return (
            <FusePageCarded
                classes={{
                    root:    classes.layoutRoot,
                    toolbar: classes.layoutToolbar
                }}
                header={
                    <div className="py-24">
                        <h4>{"Gradebook Course List"}</h4>
                    </div>
                }
                contentToolbar={
                    <Tabs
                        value={current_tab}
                        onChange={this.handleChangeTab}
                        indicatorColor="primary"
                        textColor="primary"
                        classes={{
                            root: classes.tabsRoot
                        }}
                    >
                        <Tab
                            classes={{
                                root: classes.tabRoot
                            }}
                            label="Course List"
                        />
                        {/* <Tab
                            classes={{
                                root: classes.tabRoot
                            }}
                            label="Statistics"
                        /> */}
                    </Tabs>
                }
                content={page_content}
            />
        )
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getCourseList:    Actions.getCourseList,
        setTableSort:     TableActions.setTableSort,
        setTableFilter:   TableActions.setTableFilter,
        setTablePageSize: TableActions.setTablePageSize,

    }, dispatch);
}

function mapStateToProps({ gradebookApp, auth, tableSort }) {
    return {
        courseList:      gradebookApp.gradebook.courseList,
        table_sort:      tableSort.table_sort,
        table_filter:    tableSort.table_filter,
        table_page_size: tableSort.table_page_size,
        is_loaded:       tableSort.is_loaded,
        auth
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(EventStudentList)));


// WEBPACK FOOTER //
// src/main/content/gradebook/GradebookList.js